import { render, staticRenderFns } from "./AdditionalBenefits.vue?vue&type=template&id=503e7bd2"
import script from "./AdditionalBenefits.vue?vue&type=script&lang=js"
export * from "./AdditionalBenefits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports